export enum CompanyStatus {
    'Susceptible' = 'Susceptible',
    'Client' = 'Client',
    'Non-Poach' = 'Non-Poach',
    'Tread Carefully' = 'Tread Carefully',
    'No Status' = 'No Status',
}
